import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  display: 'none',
};

export const TextItem: CSSObject = {
  display: 'none',
};
